// src/constants/index.ts - Shared application constants

// US States for dropdown selections
export const US_STATES = [
    'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
    'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
    'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan',
    'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
    'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio',
    'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota',
    'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia',
    'Wisconsin', 'Wyoming'
] as const;

// User roles (could also be useful)
export const USER_ROLES = [
    'super_admin',
    'org_admin',
    'host'
] as const;

// Account statuses
export const ACCOUNT_STATUSES = [
    'active',
    'inactive',
    'suspended'
] as const;

// Account types
export const ACCOUNT_TYPES = [
    'academic',
    'business'
] as const;

// Session statuses
export const SESSION_STATUSES = [
    'created',
    'live',
    'paused',
    'completed',
    'cancelled'
] as const;

// Invitation statuses
export const INVITATION_STATUSES = [
    'pending',
    'sent',
    'accepted',
    'expired'
] as const;

// Form validation constants
export const VALIDATION = {
    EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    PHONE_REGEX: /^\+?[\d\s\-\(\)]+$/,
    MIN_PASSWORD_LENGTH: 8,
    MAX_NAME_LENGTH: 100,
    MAX_EMAIL_LENGTH: 255,
} as const;

// UI Constants
export const PAGINATION = {
    DEFAULT_PAGE_SIZE: 25,
    PAGE_SIZE_OPTIONS: [10, 25, 50, 100],
} as const;

export const TABLE_LIMITS = {
    MAX_ROWS_PER_PAGE: 100,
    DEFAULT_ROWS_PER_PAGE: 25,
} as const;

// Date formats
export const DATE_FORMATS = {
    DISPLAY: 'MMM d, yyyy',
    DISPLAY_WITH_TIME: 'MMM d, yyyy h:mm a',
    INPUT: 'yyyy-MM-dd',
    ISO: 'yyyy-MM-dd\'T\'HH:mm:ss\'Z\'',
} as const;
